/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
  * Вид сообщения для неавторизованного пользователя.
  */
  app.NotAuthMessageView = app.View.extend({
    el: '.not-authorized-content',
    
    events: {
      'click .enter-button': 'showAuthForm',
      'click .create-account-button': 'showResistrationForm',
    },
    
    /**
    * Открытие формы авторизации.
    */
    showAuthForm: function () {
      Backbone.trigger(app.CQC_COMMAND_EVENT, {
        type: app.CQC_COMMAND_TYPES.showAuthForm,
      });
    },
    
    /**
    * Открытие формы регистрации.
    */
    showResistrationForm: function () {
      Backbone.trigger(app.CQC_COMMAND_EVENT, {
        type: app.CQC_COMMAND_TYPES.showRegistrationForm,
      });
    }
  });
})(jQuery);

}.call(window));